export const GENERIC_TABLE_ROW_HEIGHT_PX = 54
export const GENERIC_TABLE_HEADER_HEIGHT_PX = 50
export const GENERIC_TABLE_MAX_HEIGHT_PX = 566
export const GENERIC_TABLE_MAX_VIEWPORT_HEIGHT_PX = GENERIC_TABLE_MAX_HEIGHT_PX - GENERIC_TABLE_HEADER_HEIGHT_PX

export const GENERIC_TABLE_SKELETON_COLORS = {
  backgroundColor: '#E5E7EB',
  color: '#D1D5DB'
} as const
